import type { SyntheticEvent } from "react";
import { Button } from "../base/button";
import { HorizontalContainer } from "../layout/horizontal-container";
import { Text } from "../ui/text";

interface LocationButtonProps {
  loading?: boolean;
  onClick: (e: SyntheticEvent) => void;
}

export const LocationButton = ({ loading, onClick }: LocationButtonProps) => (
  <HorizontalContainer horizontalPlacement="center">
    <Button buttonType="neutral" loading={loading} onClick={onClick} width={"full"}>
      <Text value="Finn ditt nærmeste 3T-senter" weight="bold" />
    </Button>
  </HorizontalContainer>
);
